import { configSingleStory } from "@pub/config";
import { ImageCrop } from "@sphtech/dmg-design-system";

import { ResolvedTableCUEElement } from "../../elements";
import styles from "./table.module.css";
import TableBody from "./TableBody";
import TableHead from "./TableHead";
import { replaceTableImagePlaceholders } from "./utils";

/**
 * Table features:
 * - If NO row header and NO column header set, first row will be header automatically.
 * - Alternate rows will have background colors.
 */
const Table = ({
  element,
  tableImages,
}: {
  element: ResolvedTableCUEElement;
  tableImages: Map<string, ImageCrop>;
}) => {
  const dataString = element.additionalFields.tableeditor?.value;
  const hasRowHeader = element.additionalFields.rowheader?.value;
  const hasColHeader = element.additionalFields.columnheader?.value;

  if (!dataString) {
    return;
  }
  const data = JSON.parse(dataString) as string[][];
  if (!data[0]) {
    return;
  }

  //to handle img html in table body
  if (configSingleStory.htmlInTableBody && !hasColHeader && !hasRowHeader) {
    const allowedHtmlTagsForTable = ["p", "li", "ul", "a", "img"];
    const updatedData = replaceTableImagePlaceholders(data, tableImages);

    return (
      <div className={styles.tableOverflow}>
        <table className={styles.tableStyles}>
          <TableBody
            bodyData={updatedData}
            hasColHeader={hasColHeader}
            useHTML={true}
            additionalAllowedTags={allowedHtmlTagsForTable}
          />
        </table>
      </div>
    );
  }

  if (hasColHeader && !hasRowHeader) {
    return (
      <div className={styles.tableOverflow}>
        <table className={styles.tableStyles}>
          <TableBody bodyData={data} hasColHeader={hasColHeader} />
        </table>
      </div>
    );
  }

  return (
    <div className={styles.tableOverflow}>
      <table className={styles.tableStyles}>
        <TableHead rowData={data[0]} />
        <TableBody bodyData={data.slice(1)} hasColHeader={hasColHeader} />
      </table>
    </div>
  );
};

export default Table;
